import {
  setDesignCategoryIdAction,
  setDesignEncPublicIdAction,
  setDesignIdAction, setDesignIsPublicAction,
  setDesignOrderItemIdAction,
  setDesignQuantityAction,
  setDesignOriginalQuantityAction,
  setDesignAbstractProductAction,
  setDesignProductIdAction,
  setDesignSelectedProductAttributesAction,
  setDesignInternalUidAction, setEncryptedDesignIdAction,
  setIncludeDpiEnhancementAction,
  setIncludeCanvasHangerKitAction,
} from 'src/store/design/slice';
import { Attribute } from 'src/store/design/types';
import useIntegrationLayer from 'src/util/hook/useIntegrationLayer';
import { AnyAction } from 'redux';
import { Store } from 'src/store/index';
import { ThunkDispatch } from 'redux-thunk';
import getQuantityFromUrl from 'src/util/url/getQuantityFromUrl';
import getUpscaleFromUrl from 'src/util/url/getUpscaleFromUrl';
import getHangerKitFromUrl from 'src/util/url/getHangerKitFromUrl';

const setDesignInitialStateFromIntegrationLayerOperation = () => (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
) => {
  const {
    orderItemId,
    designId,
    encryptedDesignId,
    encPublicDesignId,
    categoryId,
    isPublicDesign,
    productId,
    abstractProduct,
    internalUid,
    quantity,
  } = useIntegrationLayer();
  dispatch(setDesignOrderItemIdAction(orderItemId));
  dispatch(setDesignIdAction(designId));
  dispatch(setEncryptedDesignIdAction(encryptedDesignId));
  dispatch(setDesignEncPublicIdAction(encPublicDesignId));
  dispatch(setDesignQuantityAction(getQuantityFromUrl() || quantity));
  dispatch(setDesignOriginalQuantityAction(quantity));
  dispatch(setDesignCategoryIdAction(categoryId));
  dispatch(setDesignIsPublicAction(isPublicDesign));
  dispatch(setDesignAbstractProductAction(abstractProduct));
  dispatch(setDesignProductIdAction(productId));

  // Initialize upscale and hangerKit from URL params
  dispatch(setIncludeDpiEnhancementAction(getUpscaleFromUrl()));
  dispatch(setIncludeCanvasHangerKitAction(getHangerKitFromUrl()));

  if (abstractProduct && internalUid) {
    const product = abstractProduct.products.find((p) => p.internalUid === internalUid);
    if (product) {
      const attr: { [typeName: string]: Attribute } = {};

      product.attributes.forEach((a) => {
        attr[a.typeName] = a;
      });

      dispatch(setDesignSelectedProductAttributesAction(attr));
    }
    dispatch(setDesignInternalUidAction(internalUid));
  }
};

export default setDesignInitialStateFromIntegrationLayerOperation;
